import React, { Component, Fragment } from 'react';
import Roll from 'react-reveal/Roll';
import { Map, Marker, Popup, TileLayer } from 'react-leaflet'

export default class Contact extends Component {
    constructor(props) {
        super(props);
    }
    componentDidMount() {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    render() {
        return (
            <Fragment>
                <div className="container mt-5 mb-5">
                    <h1>Temukan Kami</h1>
                    <div className="row w-100 p-2">
                        <div className="col-lg w-100 mb-4">
                            <iframe
                                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3966.877842061193!2d106.82951367632506!3d-6.147104760259701!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2e69f5efb720c993%3A0xa4bdb81d1c5a5382!2sPT.%20Sinergi%20Karya%20Sejahtera!5e0!3m2!1sen!2sid!4v1689175386256!5m2!1sen!2sid"
                                width="100%"
                                height="450"
                                style={{ border: 0 }}
                                allowfullscreen=""
                                loading="lazy"
                                referrerpolicy="no-referrer-when-downgrade"
                            />
                        </div>
                        <div className="col w-100">
                            <h2>Informasi Kontak</h2>
                            <p className="mb-1">Jl. Pangeran Jayakarta No.143 L Jakarta Pusat 10730 </p>
                            <p className="mb-1">☏ +62 21 649 3347 | 649 5627</p>
                            <p className="mb-1">🖶 +62 21 626 1076</p>
                            <p className="mb-1">sinergikaryasejahtera@gmail.com</p>
                        </div>
                    </div>
                </div>
            </Fragment>
        );
    }
}


